import { Component, Input } from '@angular/core';
import { KeyValueModel } from '../../../core/models/misc/key-value/key-value.model';
import { KeyValueDefinitionModel } from '../../../core/models/misc/key-value/key-value-definition.model';
import { KeyValueDefinitions } from '../../../core/helpers/KeyValueDefinitions';

@Component({
    selector: 'app-add-labels',
    templateUrl: './add-labels.component.html',
    styleUrls: ['./add-labels.component.scss'],
    standalone: false
})
export class AddLabelsComponent {
	@Input() maxLabels = 10;
	@Input() labels: KeyValueModel[];
	@Input() allowDuplicateKeys = false;
	@Input() definition: KeyValueDefinitionModel = KeyValueDefinitions.LabelsDefinition;
	@Input() isEnabled = true;

	constructor() {
	    this.labels = [];
	}

	onAdd(): void {
	    this.labels.push(new KeyValueModel('', ''));
	}

	onDelete(index: number): void {
	    if (this.labels.length === 1) {
	        this.labels.splice(index, 1);
	        this.labels.push(new KeyValueModel('', ''));
	    } else {
	        this.labels.splice(index, 1);
	    }
	}

	isAddDisabled() {
	    if (this.labels) {
	        let emptyLabels = this.labels.filter((el: KeyValueModel) => el.key.name === '');
	        return emptyLabels.length > 0 || this.labels.length >= this.maxLabels;
	    } else {
	        return false;
	    }
	}

	validateLabel(label: KeyValueModel): boolean {
	    return this.validateLabelKey(label) && this.validateLabelValue(label);
	}

	validateLabelKey(label: KeyValueModel): boolean {
	    if (!label.key.name && !!label.value.name) {
	        return false;
	    }
	    let isValidatorsValid = this.definition.key.validators.every((validator) =>
	        label.key.name.match(validator.regex)
	    );
	    if (!this.allowDuplicateKeys) {
	        return isValidatorsValid && !this.isDuplicateLabelKey(label);
	    }
	    return isValidatorsValid;
	}

	validateLabelValue(label: KeyValueModel): boolean {
	    return this.definition.value.validators.every((validator) => label.value.name.match(validator.regex));
	}

	onKeyChange(labels: KeyValueModel[], label: KeyValueModel): void {
	    let validator = this.definition.key.validators.find((validator) => !label.key.name.match(validator.regex));
	    if (validator) {
	        label.key.state = validator.state;
	        label.key.message = validator.message;
	    } else if (!this.allowDuplicateKeys && this.isDuplicateLabelKey(label)) {
	        label.key.state = 'error';
	        label.key.message = this.definition.duplicateKeyMessage;
	    } else if (!label.key.name && !!label.value.name) {
	        label.key.state = 'error';
	        label.key.message = this.definition.emptyKeyMessage;
	    } else {
	        label.key.state = null;
	        label.key.message = null;
	    }
	}

	onValueChange(labels: KeyValueModel[], label: KeyValueModel): void {
	    let validator = this.definition.value.validators.find((validator) => !label.value.name.match(validator.regex));
	    if (validator) {
	        label.value.state = validator.state;
	        label.value.message = validator.message;
	    } else if (!label.key.name && !!label.value.name) {
	        label.key.state = 'error';
	        label.key.message = this.definition.emptyKeyMessage;
	    } else {
	        label.value.state = null;
	        label.value.message = null;

	        if (!label.key.name && !label.value.name) {
	            label.key.state = null;
	            label.key.message = null;
	        }
	    }
	}

	isDuplicateLabelKey(label: KeyValueModel) {
	    return label.key.name !== '' && this.labels.filter((item) => item.key.name === label.key.name).length > 1;
	}

	validateLabels(): boolean {
	    return this.labels.every((label) => this.validateLabel(label));
	}
}
